/**
 * Zod schemas for image label annotation extension.
 */
import { z } from "zod"

export const imageLabelConfigSchema = z.object({
  type: z.literal("image_label"),
  options: z
    .array(
      z.object({
        value: z.string(),
        label: z.string()
      })
    )
    .min(1),
  multi_select: z.boolean().default(false),
  series_mapping: z.boolean().default(false)
})

export const createImageLabelSchema = z.object({
  project_module_id: z.string().min(1),
  series_id: z.string().min(1),
  label_key: z.string().min(1),
  value: z.boolean(),
  mapped_series_ids: z.array(z.string()).optional()
})

export const updateImageLabelSchema = z.object({
  value: z.boolean(),
  mapped_series_ids: z.array(z.string()).optional()
})
